import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SubContent } from "../Layout";
import Button from "../Button";
import ModalDistrato from "../Modal/modal-distrato";
import usePermission from "../../hooks/usePermission";

/**
 * Card de "Encerrar Vínculo" da barra lateral do Formando.
 *
 * Vive como componente próprio porque a ação precisa aparecer em mais de uma
 * aba (Dados do Formando e Financeiro) e porque, no Financeiro, ela morava
 * dentro do bloco que só é renderizado quando existe boleto contratado — um
 * formando sem financeiro lançado simplesmente não tinha como ser distratado
 * pela tela, embora possa dever multa igual (o contrato existe antes do
 * financeiro, e o ModalDistrato não depende de nenhum dado financeiro: ele
 * mesmo busca os boletos pagos, que nesse caso são zero).
 */
export default function TraineeEndBond({ trainee, reloadTraineeData, className = "mt-3" }) {
  const canDistrato = usePermission("trainee", "distrato");
  const navigate = useNavigate();
  const [showModalDistrato, setshowModalDistrato] = useState();

  // o distrato encerra o vínculo; quem já está encerrado (ou pagando a multa de
  // um distrato anterior) não pode ser distratado de novo
  const hasFullBond =
    !trainee?.cancel && trainee?.access_status !== "limitado" && trainee?.access_status !== "encerrado";

  if (!trainee?.id || !hasFullBond || !canDistrato) return null;

  return (
    <>
      <SubContent className={className}>
        <h2 className="mini-title">Encerrar Vínculo:</h2>
        <p className="small-label mb-2 mt-1">
          Gere o distrato financeiro deste formando: cancela os pagamentos em aberto e cobra (ou reembolsa) a multa
          acordada.
        </p>
        <div className="divisor mt-3 mb-3"></div>
        <Button
          color="error"
          onClick={() => {
            setshowModalDistrato({ open: true });
          }}
          data-vertical="true"
        >
          Encerrar Vínculo (Distrato)
        </Button>
      </SubContent>
      <ModalDistrato
        show={showModalDistrato?.open}
        onHide={() => {
          setshowModalDistrato();
        }}
        trainee={trainee}
        refreshCallback={() => {
          // o distrato é registrado aqui, mas as parcelas da multa vivem na aba
          // própria — leva o gestor direto para lá. reloadTraineeData atualiza o
          // access_status no layout, que é o que faz a aba "Distrato" aparecer.
          reloadTraineeData && reloadTraineeData();
          navigate(`/trainees/distrato/${trainee?.id}`);
        }}
      />
    </>
  );
}
